"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
exports.__esModule = true;
exports.disconnect = exports.getRegistry = exports.getStakingProgress = exports.getValidators = exports.paymentInfo = exports.submitExtrinsic = exports.getMinimumBondBalance = exports.getTransactionParams = exports.getAccount = exports.verifyValidatorAddresses = exports.isControllerAddress = exports.isNewAccount = exports.isElectionClosed = exports.getOperations = void 0;
/*

// Alternative Implementations provided for example or future implementations

export { getOperations } from "./subscan";

export {
  isElectionClosed,
  isNewAccount,
  isControllerAddress,
  verifyValidatorAddresses,
  getAccount,
  getTransactionParams,
  submitExtrinsic,
  paymentInfo,
  getValidators,
  getStakingProgress,
  getRegistry,
  disconnect,
} from "./websocket";

*/
var bisontrails_1 = require("./bisontrails");
__createBinding(exports, bisontrails_1, "getOperations");
var sidecar_1 = require("./sidecar");
__createBinding(exports, sidecar_1, "isElectionClosed");
__createBinding(exports, sidecar_1, "isNewAccount");
__createBinding(exports, sidecar_1, "isControllerAddress");
__createBinding(exports, sidecar_1, "verifyValidatorAddresses");
__createBinding(exports, sidecar_1, "getAccount");
__createBinding(exports, sidecar_1, "getTransactionParams");
__createBinding(exports, sidecar_1, "getMinimumBondBalance");
__createBinding(exports, sidecar_1, "submitExtrinsic");
__createBinding(exports, sidecar_1, "paymentInfo");
__createBinding(exports, sidecar_1, "getValidators");
__createBinding(exports, sidecar_1, "getStakingProgress");
__createBinding(exports, sidecar_1, "getRegistry");
__createBinding(exports, sidecar_1, "disconnect");
//# sourceMappingURL=index.js.map